import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Panel, Empty, axis, grid, tip, C } from "./chartTheme";
import { byHour, byWeekday } from "../../lib/reports";

const Pattern = ({ data }) => (
  <ResponsiveContainer width="100%" height={220}>
    <ComposedChart data={data}>
      <CartesianGrid {...grid} />
      <XAxis dataKey="key" {...axis} />
      <YAxis yAxisId="l" {...axis} />
      <YAxis yAxisId="r" orientation="right" {...axis} unit="%" />
      <Tooltip {...tip} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
      <Legend wrapperStyle={{ fontSize: 10 }} />
      <Bar yAxisId="l" dataKey="dl" name="Avg ↓ Mbps" fill={C.blue} isAnimationActive={false} />
      <Line yAxisId="r" dataKey="issueRate" name="Issue %" stroke={C.red} strokeWidth={2} dot={{ r: 2 }} isAnimationActive={false} />
    </ComposedChart>
  </ResponsiveContainer>
);

export const TimePatterns = ({ tests }) => (
  <>
    <Panel title="Hour of day pattern" testId="report-hourly">{tests.length ? <Pattern data={byHour(tests)} /> : <Empty />}</Panel>
    <Panel title="Weekday pattern" testId="report-weekday">{tests.length ? <Pattern data={byWeekday(tests)} /> : <Empty />}</Panel>
  </>
);
